module.exports = __webpack_public_path__ + "img/news_cancer.a20cbc44.jpg";